export default (params) => ({
  trigger: {
    name: 'product_trade_in.deselect_offer',
    params: params,
  },
  config: {
    schema: {
      sub_feature: {
        enum: [
          'default',
          'recognized',
        ],
      },
    },
    event: {
      name: 'deselect_content',
      params: {
        content: 'offer',
      },
    },
  },
});
